import { render } from "./add-uni-dialog.vue?vue&type=template&id=1bba72a8&ts=true"
import script from "./add-uni-dialog.vue?vue&type=script&lang=ts"
export * from "./add-uni-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__